<script setup lang="ts">
import type { AppRequestRoute } from '@shared/config'

import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import { useDayjs } from '@shared/lib/format'
import { AppDatePicker } from '@shared/ui/fields'
import { CardAdmin } from '@shared/ui/cards'
import { BtnPrimary } from '@shared/ui/buttons'

import { useHelperAction } from '../../api/helpers/action.hook'

defineOptions({
  name: 'HelperDateRangeCard',
})

const props = defineProps<HelperDateRangeCardProps>()

interface HelperDateRangeCardProps {
  title: string
  routeName: AppRequestRoute
}

const dayjs = useDayjs()
const { run, isRunning, canRun } = useHelperAction()

const refFrom = ref<string>('')
const refTo = ref<string>('')

const isValid = computed<boolean>(() => Boolean(refFrom.value && refTo.value))

const send = async (): Promise<void> => {
  const from = dayjs(refFrom.value).startOf('day').format(DateFormat.Default)
  const to = dayjs(refTo.value).endOf('day').format(DateFormat.Default)

  const ok = await run(props.routeName, { from, to })

  if (ok) {
    refFrom.value = ''
    refTo.value = ''
  }
}
</script>

<template>
  <CardAdmin
    :title="title"
    fullwidth
  >
    <div class="helper-date-range">
      <AppDatePicker
        :value="refFrom"
        label="From"
        placeholder="Select from date"
        @change="refFrom = $event"
      />
      <AppDatePicker
        :value="refTo"
        label="To"
        placeholder="Select to date"
        @change="refTo = $event"
      />
      <BtnPrimary
        text="send"
        :disabled="!canRun || isRunning || !isValid"
        @click="send"
      />
    </div>
  </CardAdmin>
</template>

<style scoped lang="scss" src="./HelperDateRangeCard.scss" />
